import { ProductModelType } from '@teinor/erp/types/company/product';
import { VariantsPayload } from '../reducers/products/variants';
import { TwinDictionary } from './dictionary';
import { displayFormatedNumber } from './numbers';

export const makeVariantGroupMainIdFirst = (orderedGroupsJson: TwinDictionary, VariantGroupMainId: number) => {
    let found = false
    const theoricalDict: TwinDictionary = {}
    for (const key in orderedGroupsJson) {
        const item = orderedGroupsJson[key]
        if (String(key) !== String(VariantGroupMainId)) {
            theoricalDict[key] = parseInt(item) + 1
        } else {
            theoricalDict[key] = 0
            found = true
        }
    }
    return found ? theoricalDict : orderedGroupsJson
}

export const makeVariantGroupMainIdLast = (orderedGroupsJson: TwinDictionary, VariantGroupMainId: number, subProducts: ProductModelType[]) => {
    const usedGroups = new Set()
    for (const element of subProducts) {
        if (element?.ProductVariantGroup?.VariantValues) {
            for (const variantValue of element?.ProductVariantGroup?.VariantValues) {
                usedGroups.add(variantValue.VariantGroupId)
            }
        }
    }
    let myMain = VariantGroupMainId
    const copyOrderedGroupsJson = JSON.parse(JSON.stringify(orderedGroupsJson))
    for (const key in copyOrderedGroupsJson) {
        if (!usedGroups.has(parseInt(key))) {
            delete copyOrderedGroupsJson[key]
        }
    }
    if (!VariantGroupMainId || !copyOrderedGroupsJson[VariantGroupMainId]) {
        let myOrder = Infinity
        for (const key in copyOrderedGroupsJson) {
            const item = copyOrderedGroupsJson[key]
            if (item < myOrder) {
                myMain = parseInt(key)
                myOrder = item
            }
        }
    }
    copyOrderedGroupsJson[myMain] = Object.keys(copyOrderedGroupsJson).length + 2
    return { orderedGroupsJson: copyOrderedGroupsJson, myMain }
}

type SumsSort = [TwinDictionary, string][]

export const sortVariantProducts = (data: TwinDictionary[], variants: VariantsPayload) => {
    const elementsSums: SumsSort = []
    const dataParsed = []
    const groupsUsed = new Set<number>()
    if (variants?.orderedValuesJson) {
        for (const key in data) {
            const row = data[key]
            const values = row.ProductVariantGroup?.VariantValues
            const variantsParsed: TwinDictionary = {}
            for (const element of values) {
                groupsUsed.add(element.VariantGroupId)
                variantsParsed[element.VariantGroupId] = element.id
            }
            dataParsed.push(JSON.parse(JSON.stringify({ ...row, variantsParsed: variantsParsed })))
        }
        const valuesSort = Array.from(groupsUsed).sort((a: any, b: any) => variants.orderedGroupsJson[a] - variants.orderedGroupsJson[b])
        for (const key in dataParsed) {
            const row = dataParsed[key]
            let sortIndex = []
            const values = row.ProductVariantGroup?.VariantValues
            values.sort((a: any, b: any) => variants.orderedGroupsJson[a.VariantGroupId] - variants.orderedGroupsJson[b.VariantGroupId])
            for (const element of valuesSort) {
                sortIndex.push(variants?.orderedValuesJson[row.variantsParsed[element]] + 1000)
            }
            elementsSums.push([row, sortIndex.join('-')])
        }
    }
    const sorted = elementsSums.sort((a, b) => {
        if (a[1] < b[1]) {
            return -1
        } else if (a[1] > b[1]) {
            return 1
        }
        return 0
    })
    return sorted.map((item) => item[0])
}

export const productTypeCategoryTy = {
    0: 0,
    1: 1,
    2: 2,
    3: 0,
    4: 0,
    5: 5,
    6: 0
}

export const prepareFormatedMeasureQuantity = (value: number, measure: number, controlUnitType: number, translation: string) => {
    let tag: string | number = measure
    if (controlUnitType === 0) {
        tag = translation
    }
    const number = displayFormatedNumber(value)
    return number + ' ' + tag
}